import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=6b15eca7&scoped=true&"
import script from "./MainTitle.vue?vue&type=script&lang=ts&"
export * from "./MainTitle.vue?vue&type=script&lang=ts&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=6b15eca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b15eca7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
